/** The district register export page (Planning Phase 3 P3-6a): the committed land-use layer, one district a file. */
export default {
  registerExport: {
    navLabel: 'District export',
    title: 'District register export',
    subtitle: 'The committed land-use layer (the K layer) for PLANMalaysia, one district a file.',
    notPermitted: 'Only an administrator or an approver may export the register.',
    unavailable: 'The district export opens with the KM procedure. It is not available yet.',
    area: 'District',
    areaPlaceholder: 'Choose a district',
    sequence: 'Sequence number',
    sequenceHint:
      'Proposed: {{proposed}}. Any number from 01 to 99; reusing an earlier number leaves the proposal as it is.',
    sequenceInvalid: 'Enter a number from 1 to 99.',
    fileName: 'File name: {{name}}',
    periodFrom: 'Approved from',
    periodTo: 'Approved to',
    periodHint: 'Leave both dates empty to export every permission in force.',
    submit: 'Export',
    submitting: 'Queuing…',
    queued: 'The export was queued. It usually takes a few minutes.',
    recent: 'Recent exports',
    none: 'No exports yet.',
    download: 'Download',
    downloading: 'Preparing…',
    showReport: 'Show report',
    hideReport: 'Hide report',
    reportTitle: 'Validation report',
    passed: 'Passed',
    notPassed: 'Not passed',
    counts: '{{rows}} rows from {{cases}} submissions',
    rate: '{{name}}: {{rate}}',
    limit: 'limit {{limit}}',
    overlap: 'Overlap',
    gap: 'Gap',
    failuresTitle: 'Must be fixed before sending',
    warningsTitle: 'To check',
    cases: 'Submissions: {{refs}}',
    fields: 'Fields: {{fields}}',
    columns: {
      file: 'File',
      area: 'District',
      status: 'Status',
      rows: 'Rows',
      size: 'Size',
      requested: 'Requested',
      actions: 'Actions',
    },
    status: { queued: 'Queued', running: 'Building', done: 'Ready', failed: 'Failed' },
    errorCodes: {
      REGISTER_EXPORT_FAILED: 'The export failed. Try again; if it fails again, contact support.',
      REGISTER_EXPORT_EMPTY: 'No permission in force in this district could be exported.',
      REGISTER_EXPORT_TOO_LARGE: 'The file would be too large to send.',
      REGISTER_EXPORT_STALE: 'The export stopped before it finished. Start it again.',
    },
    failures: {
      no_rows: 'No row was exported.',
      overlap_rate: 'Plots overlap more than the limit allows.',
      gap_rate: 'Plots leave more of their sites uncovered than the limit allows.',
      empty_attributes: 'Required fields are empty on some rows.',
      truncated: 'Some values are longer than their field allows.',
      gtn_paths: 'Some rows carry a land-use class path the official list does not have.',
      lot_duplicates: 'One lot number appears in more than one submission of a mukim.',
      refused_rows: 'Some rows were drawn in the Kertau datum and were left out.',
    },
    warnings: {
      without_upi: 'Some rows have no UPI.',
      missing_area: 'Some permissions in force name no district and were not exported.',
      legacy_without_decision_number: 'Approvals made before decisions were numbered have no certificate number.',
      imported_without_rows: 'Granted submissions imported from another system have no rows here.',
      local_without_rows: 'Some granted submissions of this district have no exported row.',
    },
    tiers: {
      title: 'Land-use classes, tiers 2 and 3',
      intro: 'Import the official tier 2 and tier 3 classes as a JSON file. The export writes their text and code.',
      count: '{{count}} classes imported',
      none: 'No tier 2 or tier 3 classes imported yet.',
      import: 'Import JSON',
      download: 'Download JSON',
      clear: 'Remove all',
      save: 'Save classes',
      saving: 'Saving…',
      saved: 'Classes saved.',
      cancel: 'Cancel',
      pending: '{{count}} classes ready to save',
      invalid: {
        json: 'That file is not valid JSON.',
        shape:
          'Entry {{position}} is not a valid class (code, parent, tier 2 or 3, official text, code of up to 7 capitals).',
        too_many: 'A file may hold at most 600 classes.',
        duplicate: 'Entry {{position}} repeats a class code.',
      },
    },
  },
  errors: {
    invalid_register_export: 'Those export details are not valid.',
    register_export_unavailable: 'The district export opens with the KM procedure. It is not available yet.',
    register_export_not_found: 'That export was not found.',
    register_export_not_ready: 'That export is not ready yet.',
    too_many_register_exports: 'An export is already being built. Wait for it to finish.',
  },
} as const
